<template>
  <form class="rform">
    <slot />

    <div v-if="showActions" class="rform__actions">
      <button
        v-if="showCancel"
        type="button"
        class="rform__btn rform__btn--ghost"
        :disabled="loading"
        @click="$emit('cancel')"
      >
        {{ cancelLabel }}
      </button>
      <button type="submit" class="rform__btn rform__btn--primary" :disabled="loading">
        <span v-if="loading" class="rform__spinner"></span>
        {{ loading ? loadingLabel : submitLabel }}
      </button>
    </div>
  </form>
</template>

<script setup>
defineProps({
  showActions: { type: Boolean, default: true },
  showCancel: { type: Boolean, default: false },
  submitLabel: { type: String, default: 'Save' },
  cancelLabel: { type: String, default: 'Cancel' },
  loading: { type: Boolean, default: false },
  loadingLabel: { type: String, default: 'Saving...' },
})

defineEmits(['cancel'])
</script>
